import React, { Component } from "react";
import { Container, Row, Col, CardImg } from "reactstrap";

import FAQ from "../../../FAQ/faq";
import faqs from "./qa";
import './style.css';

import CourseHero from "../../CourseComponents/Hero/courseHero";
import BackgroundImage from "../../../images/ex-hero2-v2.png";
import HowToApply from "../../CourseComponents/How-To-Apply/how-to-apply";
import CourseOverview from "../../CourseComponents/CourseOverview/courseOverview";
import WeekOverview from "../../CourseComponents/WeekOverview/weekOverview";
import WeekCard from "../../CourseComponents/WeekCards/weekCard";
import CareerSupport from "../../CourseComponents/CareerSupport/careerSupport";
import ProgramDates from "../../CourseComponents/ProgramDates/programDates";
import ProgramCard from "../../CourseComponents/ProgramCard/programCard";
import FinanceOptions from "../../CourseComponents/FinanceOptions/financeOptions";
import { Helmet } from "react-helmet";

export default class ExpDesign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courseName: "Experience Design",
      courseType: "Immersive",
      courseHours: "Full-Time",
      overview: {
        time: "Full-Time",
        weeks: "12 Weeks",
        hours: "330 Hours",
        teaser: "Become A Consultant For Experience And Digital Service Design",

        overview: `The Experience Design (UX & CX) Immersive prepares a
                  student to become an experience designer or a digital
                  service design consultant, which has no license
                  requirements for general work in this career field. You’ll
                  end this course equipped with experience in design
                  thinking, user research, prototyping, service design,
                  storytelling, and more.`
      },
      weeksubtext: `Dive into the experience design environment and the basics
                    of design thinking, lean/agile frameworks, and service
                    design. Discover how to design and build prototypes that
                    meet user needs, how to work with developers, and work
                    collaboratively in a DevOps team.`,
      card1: {
        title: "Week 1-2",
        subtitle: "Design Thinking & User Research",
        topics: [
          "Design Thinking - What is it not?",
          "B2C, B2B, B2Beyond User Research"
        ]
      },
      card2: {
        title: "Week 3-4",
        subtitle: "Digital Product Design & Digital Tools",
        topics: [
          "Roles & Information Architecture",
          "Pen, Paper, Post-Its & Tools"
        ]
      },
      card3: {
        title: "Week 5-8",
        subtitle:
          "Service Design, Application Wireframes, Front-end Development",
        topics: ["Customer Journey Mapping", "Value Promise"]
      },
      card4: {
        title: "Week 9-10",
        subtitle: "Design Leadership & Storytelling",
        topics: ["See the Human-Centric World", "The Big Picture"]
      },
      card5: {
        title: "Week 10-12",
        subtitle: "Capstone Portfolio Projects",
        topics: ["Design Extraordinaire"]
      }
    };
  }
  render() {
    return (
      <div className="overflow">
           <Helmet>
          <meta charSet="utf-8" />
          <title>Lighthouse</title>
          <link rel="canonical" href="http://atlighthouse.com" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Lighthouse"></meta>
          <meta property="og:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta property="og:url" content="https://atlighthouse.com"></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@at_lighthouse"></meta>
          <meta name="twitter:title" content="Lighthouse"></meta>
          <meta name="twitter:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta name="twitter:url" content="https://atlighthouse.com"></meta>
          <meta
            name="description"
            content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."
          />
  
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <meta
            name="keywords"
            content="Coding Bootcamps, Technology Bootcamps, Tech bootcamps, Business and technology bootcamps, 
              Business bootcamps, Bootcamp, Programming, Become a Developer, Become a Software Developer, Learn Code,
              Get Hired for coding, Immersive program, Intensive program, Atlanta Coding bootcamps, Best coding bootcamps,Top coding bootcamps in Atlanta, Free coding bootcamp, Job guarantee bootcamp, Bootcamp with job guarantee,
              Steps to becoming a developer, Steps to becoming a web developer, Steps to becoming a software engineer, How to become a developer, How to become a programmer, How to become a web developer, How to become a full stack web developer, How to become a full stack developer, How to become a software developer, How to become a software engineer, How to become a data scientist, How to become a data analyst, How to become a digital marketer, How to become a UX designer, How to become an experience designer, How to become a UI designer, Coding bootcamp with job guarantee, Full time coding bootcamps, Part time coding bootcamps, Learn full stack web development, Learn web development, Learn software engineering, Learn data science, Learn data analytics, Learn digital marketing, Learn experience design, Learn ux design, Learn ui design, Full Stack Web Development Course, Full Stack Web Development Bootcamp, Full Stack Web Development Program, Full Stack Web Development Certificate, Atlanta Full Stack Development Course, Atlanta Full Stack Development Bootcamp, Atlanta Full Stack Development Program, Atlanta Full Stack Development Certificate, Data Science Course, Data Science Bootcamp, Data Science Program, Data Science Certificate, Atlanta Data Science Course, Atlanta Data Science Bootcamp, Atlanta Data Science Program, Atlanta Data Science Certificate, Software Engineering Course, Software Engineering Bootcamp, Software Engineering Program, Software Engineering Certificate, Atlanta Software Engineering Course, Atlanta Software Engineering Bootcamp, Atlanta Software Engineering Program, Atlanta Software Engineering Certificate, Digital Marketing Course, Digital Marketing Bootcamp, Digital Marketing Program, Digital Marketing Certificate, Atlanta Digital Marketing Course, Atlanta Digital Marketing Bootcamp, Atlanta Digital Marketing Program, Atlanta Digital Marketing Certificate, UX Course, UX Certificate, UX Bootcamp, UX Program, Atlanta UX Course, Atlanta UX Certificate, Atlanta UX Bootcamp, Atlanta UX Program, Competitive programming, How to get a job in programming, Bootcamps for college students, Coding bootcamps for college students, Best coding bootcamps in atlanta, Top rated coding bootcamps in atlanta, Top rated coding bootcamps, Best coding bootcamps, Rigorous coding bootcamps, Data Science bootcamps for college students, Best Data Science bootcamps in atlanta, Top rated Data Science bootcamps in atlanta, Top rated Data Science bootcamps, Best Data Science bootcamps, Can you get a job out of a coding bootcamp?, Talent Marketplace, Technology skills, Technology career, Career in software engineering, Career in data science, Career in digital marketing, Career in ux design, Career, Learn, Programming, Coding, Machine learning courses, Web development courses"
          />
          <meta name="theme-color" content="#000000" />
        </Helmet>
        <CourseHero
          courseName={this.state.courseName}
          courseType={this.state.courseType}
          courseHours={this.state.courseHours}
          cName='ex-design-jumbo'
          webSource='Ux_design_ft_v1'
        />

        <div className="all-pages">
          <CourseOverview
            time={this.state.overview.time}
            weeks={this.state.overview.weeks}
            hours={this.state.overview.hours}
            overview={this.state.overview.overview}
            teaser={this.state.overview.teaser}
          >
            <CardImg
              className="rounded-0"
              top
              height="auto"
              src="img/exp-design-icon-v2.png"
              alt="Card image cap"
            />
          </CourseOverview>

    
          <section>
            <Container>
                <Row className=" justify-content-center justify-content-md-start">
                  <Col xs={{ size: 12 }} lg={{ size:11, offset: 1}} className="text-left ditl-headline">
                    <h1> A Learning Adventure Each Day</h1>
                  </Col>
                </Row>

                <Row className="">
                  <Col lg={{ size: 5, offset: 1 }}>
                    <Row className=" left-align pt-5">
                      <Col>
                        <h3 className=" left-align">
                          5 Days a Week.{" "}
                        </h3>
                      </Col>
                    </Row>
                    <Row className="left-align">
                      <Col>
                        <h3>Monday Through Friday</h3>
                      </Col>
                    </Row>
                    <Row className="left-align">
                      <Col className="" lg={{ size: 11 }}>
                        <p>
                          Each day is designed to inspire you to learn and grow
                          with experience. Below is an overview of the
                          activities that you’ll experience throughout the day.{" "}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        className="ditl-list left-align pl-0 pr-0 text-center text-lg-left"
                        xs={{ size: 5 }}
                      >
                        {" "}
                        <ul className="py-0">
                          <li>Standups</li>
                          <li>Lectures & Workshops</li>
                          <li>Design Challenges</li>
                          <li>Lunch</li>
                        </ul>{" "}
                      </Col>
                      <Col
                        className="ditl-list left-align ml-4 text-center text-lg-left"
                        xs={{ size: 5 }}
                      >
                        <ul className="py-0 pl-0">
                          <li>Call with Mentor</li>
                          <li>Meetups</li>
                          <li>Project TIme</li>
                          <li>Career Coaching</li>
                        </ul>
                      </Col>
                    </Row>
                  </Col>
                  <Col className="d-none d-lg-block" md={{ size: 5 }}>
                    <CardImg
                      className="clear-card ml-n5"
                      top
                      width="100%"
                      src="img/exp-collage-v2.png"
                      alt="Card image cap"
                    />
                  </Col>
                </Row>
            </Container>
          </section>


          <WeekOverview subtext={this.state.weeksubtext}>
            <Row className="justify-content-center">
              <WeekCard
                sm="6"
                lg="2"
                title={this.state.card1.title}
                subtitle={this.state.card1.subtitle}
                topics={this.state.card1.topics}
              />
              <WeekCard
                sm="6"
                lg="2"
                title={this.state.card2.title}
                subtitle={this.state.card2.subtitle}
                topics={this.state.card2.topics}
              />
              <WeekCard
                sm="6"
                lg="2"
                title={this.state.card3.title}
                subtitle={this.state.card3.subtitle}
                topics={this.state.card3.topics}
              />
              <WeekCard
                sm="6"
                lg="2"
                title={this.state.card4.title}
                subtitle={this.state.card4.subtitle}
                topics={this.state.card4.topics}
              />
              <WeekCard
                sm="6"
                lg="2"
                title={this.state.card5.title}
                subtitle={this.state.card5.subtitle}
                topics={this.state.card5.topics}
              />
            </Row>
          </WeekOverview>
          <CareerSupport>
            <CardImg
              className="career-support-img"
              top
              height="100%"
              width="100%"
              src="img/ex-career-v2.png"
              alt="Card image cap"
            />
          </CareerSupport>

          <HowToApply />

          <ProgramDates>
            <ProgramCard
              days="Nov 18, 2019 - Feb 10, 2020"
              time="Mon to Fri: 9:00AM - 5:00PM"
              exclude="Excluding: Nov 11, Nov 28, Nov 29, Dec 23 - Dec 27, Dec 30, Dec31, Jan 1"
            />
            <ProgramCard
              days="Jan 6, 2020 - Mar 3, 2020"
              time="Mon to Fri: 9:00AM - 5:00PM"
            />
          
          </ProgramDates>

          <FinanceOptions tuition="$11,950" />

          <FAQ faqs={faqs} />
        </div>
      </div>
    );
  }
}
